<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        :class="['accounting-summary-detail-dialog', 'ah-accounting-detail-dialog', { print: isPrinting }]"
        top="2vh"
        append-to-body
        :before-close="() => onBeforeClose()"
        :lock-scroll="false"
        @open="onOpen"
    >
        <div class="dialog-grid" :class="{ wideDetail: QueryType === 7 }">
            <div class="detail-area">
                <div class="area-header">
                    <div style="display: flex; gap: 16px; align-items: center">
                        <strong>{{ titleName }}</strong>
                    </div>
                    <div class="actions"></div>
                </div>
                <div class="detail-card-scrollview">
                    <template v-if="isLoadingData">
                        <div></div>
                    </template>
                    <template v-else>
                        <template v-if="datas.detail">
                            <!-- 待檢核 -->
                            <div v-if="datas.detail.vocherStatus === 0" class="accounting-check-bar wait-for-check">
                                <div class="title"><span class="label">待財會檢核</span></div>
                                <div class="action" v-if="isAuth('G10') && !isQR()">
                                    <el-tooltip content="不被統計於會計總帳、資產負債表、損益表...等會計報表。" placement="bottom" effect="dark">
                                        <el-button size="mini" icon="el-icon-close" @click="changeStatus('no-accounting-need')">不作帳</el-button>
                                    </el-tooltip>
                                    <el-tooltip :content="isVoucherStatusDisabled ? '尚有傳票未核准，無法完成財會檢核。' : '交易及傳票作業完成。'" placement="bottom" effect="dark">
                                        <el-button :disabled="isVoucherStatusDisabled" type="primary" size="mini" icon="el-icon-check" @click="changeStatus('complete')">完成</el-button>
                                    </el-tooltip>
                                </div>
                            </div>
                            <!-- 完成 -->
                            <div v-if="datas.detail.vocherStatus === 1" class="accounting-check-bar complete">
                                <div class="title">
                                    <el-tooltip content="交易及傳票作業完成。若要修改傳票，請財務人員恢復至待檢核。">
                                        <span class="label"><i class="el-icon-check"></i><span>已完成財會檢核</span></span>
                                    </el-tooltip>
                                </div>
                                <span class="last-status-mutate-info">
                                    檢核人：{{ documentDetail.voucherStatusUpdateName }}({{ documentDetail.voucherStatusUpdateDate | dateFormater("YYYY-MM-dd") }})
                                </span>
                                <div class="action" v-if="isAuth('G10') && !isQR()">
                                    <el-dropdown trigger="click" @command="onStatusDropdown">
                                        <span class="el-dropdown-link">
                                            <el-button icon="el-icon-more" size="mini" style="padding: 6px 8px; border: 0; margin-left: 8px"></el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item icon="el-icon-refresh-left" command="wait-for-check">恢復為待檢核</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                            <!-- 不作帳 -->
                            <div v-if="datas.detail.vocherStatus === 2" class="accounting-check-bar no-accounting-need">
                                <div class="title">
                                    <el-tooltip content="不被統計於會計總帳、 資產負債表、損益表...等會計報表。">
                                        <span class="label">不作帳</span>
                                    </el-tooltip>
                                </div>
                                <span class="last-status-mutate-info">
                                    編輯人：{{ documentDetail.voucherStatusUpdateName }}({{ documentDetail.voucherStatusUpdateDate | dateFormater("YYYY-MM-dd") }})
                                </span>
                                <div class="action" v-if="isAuth('G10') && !isQR()">
                                    <el-dropdown trigger="click" @command="onStatusDropdown">
                                        <span class="el-dropdown-link">
                                            <el-button icon="el-icon-more" size="mini" style="padding: 6px 8px; border: 0; margin-left: 8px"></el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item icon="el-icon-refresh-left" command="wait-for-check">恢復為待檢核</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </template>
                        <AccountingDocumentDetail
                            :datas="datas"
                            :queryType="QueryType"
                            :isEditing="isEditing"
                            @generate-payment-voucher="onGeneratePaymentVoucher"
                            @generate-reimbursement-invoice-voucher="onGenerateReimbursementInvoiceVoucher"
                            @detailClose="onDetailClose"
                            @detail-data-changed="onDetailDataChanged"
                            @regenerate-vouchers="onDetailRequestRegenerateVouchers"
                        />
                    </template>
                </div>
            </div>
            <div class="voucher-area">
                <div class="area-header">
                    <div v-if="!isLoadingVouchers">
                        <span>共 {{ vouchers.length }} 張傳票</span>
                    </div>
                    <div v-if="isLoadingVouchers">載入中...</div>
                    <div class="actions">
                        <template v-if="isAccountingWaitForCheck">
                            <el-tooltip v-if="isSwitchShow && !paymentWithholdItem" content="財會檢核已完成" :manual="!isAccountingComplete" placement="top" effect="dark">
                                <el-button
                                    v-if="showRegenerateVoucherButton"
                                    size="mini"
                                    icon="el-icon-refresh"
                                    :disabled="(!isPayed('G01') && !isAuth('admin')) || isAccountingComplete || isQR()"
                                    :loading="isActionLoading"
                                    @click="onBulkReAutoVoucher"
                                >重新自動產生傳票</el-button>
                            </el-tooltip>
                            <el-tooltip v-if="isAuth('G09') && vouchers.length && !isQR()" content="財會檢核已完成" :manual="!isAccountingComplete" placement="top" effect="dark">
                                <span style="margin: 0 10px; padding: 5px 0">
                                    <el-button
                                        size="mini"
                                        :loading="isActionLoading"
                                        :type="isBatchApprove ? 'success' : ''"
                                        :icon="isBatchApprove ? 'el-icon-check' : 'el-icon-refresh-left'"
                                        :disabled="(!isPayed('G01') && !isAuth('admin')) || isAccountingComplete"
                                        @click="onBatchUpdateVoucherStatus"
                                        >{{ isBatchApprove ? "核准所有傳票" : "批次取消核准" }}</el-button
                                    >
                                </span>
                            </el-tooltip>
                        </template>
                        <el-tooltip v-if="isAuth('G06') && !paymentWithholdItem && !isQR()" content="財會檢核已完成" :manual="!isAccountingComplete" placement="top" effect="dark">
                            <span style="margin-right: 10px">
                                <el-button
                                    size="mini"
                                    icon="el-icon-plus"
                                    :disabled="(!isPayed('G01') && !isAuth('admin')) || isEditing || !isAccountingWaitForCheck"
                                    :loading="isActionLoading"
                                    @click="addVoucher(null)"
                                    >新增傳票</el-button
                                >
                            </span>
                        </el-tooltip>
                        <el-button v-if="vouchers.length" size="mini" @click="onPrintVouchers" icon="el-icon-printer" :disabled="!isPayed('G01') && !isAuth('admin')"></el-button>
                        <el-button size="mini" @click="onBeforeClose(true)" icon="el-icon-close"></el-button>
                    </div>
                </div>
                <div class="voucher-card-scrollview">
                    <div v-if="paymentWithholdItem && vouchers.length === 0">
                        <div style="margin: 100px; color: #888; text-align: center">
                            已在 <el-button type="text" @click="openPaymentDetail(paymentWithholdItem.payoutSno)">{{ paymentWithholdItem.payoutNo }}</el-button> 自動產生
                        </div>
                    </div>
                    <!-- <div v-if="!isPayed('G01')" class="unpaid-msg">
                        <div class="title">您尚未購買「會計專區」功能</div>
                        <div class="description">
                            <div>
                                會計專區包含：自動做傳票、即時綜合損益表、資產負債表、會計科目總分類帳....等，並提供財會檢核流程、匯出會計報表...。如欲訂用，請
                                <a href="https://www.sokuji.tw/contact" target="_blank">聯繫我們</a>。
                            </div>
                            <div></div>
                        </div>
                    </div> -->
                    <div style="position: relative">
                        <component v-if="isUnbalanceAlertShow" :is="`${unbalanceAlert}UnbalanceAlert`" :datas="datas" :vouchers="vouchers" />
                        <VoucherCard
                            :style="{ opacity: isNoAccountingNeed ? '0.5' : '1' }"
                            v-for="voucher in vouchers"
                            :queryType="QueryType"
                            :accountTypeSno="sno"
                            :voucherData="voucher"
                            :key="`${voucher.vono}${voucher.status}`"
                            :editable="isAccountingWaitForCheck"
                            :titleName="content"
                            :isOtherVoucherEditing="isEditing"
                            :UNT_NBR="UNT_NBR"
                            @edit="onEditVoucher"
                            @approve="onApproveMutated"
                            @cancelApprove="onApproveMutated"
                            @cancel="onCancelVoucher"
                            @submit="onSubmitVoucher"
                            @delete="onDeleteVoucher"
                            @void="onVoidVoucher"
                            @cancelVoid="onCancelVoidVoucher"
                            @duplicate="onDupicateVoucher"
                        />
                    </div>
                </div>
                <div id="accounting-detail-bottom-scroll-anchor"></div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { accountingStatusOptions } from '@/assets/commonData/options';
import _ from 'lodash';
import moment from 'moment';
import AccountingDocumentDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingDocumentDetail.vue';
import InvoiceUnbalanceAlert from '@/components/dashboard/Accounting/AccountingSummary/AccountingUnbalanceAlert/InvoiceUnbalanceAlert.vue';
import PaymentUnbalanceAlert from '@/components/dashboard/Accounting/AccountingSummary/AccountingUnbalanceAlert/PaymentUnbalanceAlert.vue';
import VoucherCard from './ui/VoucherCard.vue';

export default {
    name: 'AccountingDetailDialog',
    components: {
        AccountingDocumentDetail,
        VoucherCard,
        InvoiceUnbalanceAlert,
        PaymentUnbalanceAlert,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        QueryType: {
            type: Number,
            default: null,
        },
        sno: {
            type: [Number, Object],
            default: null,
        },
    },
    data() {
        return {
            isEditing: false,
            isEdited: false,
            isPrinting: false,
            isLoadingVouchers: false,
            isLoadingData: false,
            isShowCanceledVouchers: false,
            isActionLoading: false,
            accountingStatusOptions,
            datas: {
                sno: null,
                vocherStatus: null, // 傳票狀態
                uniqueNumber: null, // 系統單號
                createDate: null, // 交易日期
                name: null, // 摘要
                typeName: null, // 收支項目
                amount: null, // 交易金額
                tax_Amount: null, // 稅金
                credentialsName: null, // 憑證類型名稱
                withholdingTax_Labor: null, // 勞務税
                withholdingTax_Health2: null, // 二代健保
                payType: null, // 交易方式 1零用現金 2轉帳
            },
            vouchers: [],
            editingVoucher: {
                vono: 0,
            },
            accItemsToDelete: [],

            originalVocherStatus: null,
            paymentWithholdSno: null,
        };
    },
    watch: {
        async visible(newValue) {
            if (newValue) {
                this.isLoadingVouchers = true;
                await this.updateData();
                this.fetchVouchers();
            } else {
                this.clearDatas();
            }
        },
    },
    computed: {
        userGroupNo() {
            return this.$store.getters['account/userGrP_NO'];
        },
        showRegenerateVoucherButton() {
            if (this.userGroupNo === 'OT1' || this.userGroupNo === 'OT6') return false;
            return true;
        },
        emptyAccountingItemVoucherList() {
            const emptyAccountingItemVoucherList = [];

            this.vouchers.forEach((voucher) => {
                const FOUND = _.find(voucher.accountItems, ['accno', null]);
                if (FOUND) emptyAccountingItemVoucherList.push(voucher.serialNumber);
            });

            return emptyAccountingItemVoucherList;
        },
        generateType() {
            switch (this.QueryType) {
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 4;
            case 5:
                return this.documentDetail.froM_UNT === 'REM_FEE' ? 12 : 5;
            case 6:
                return 6;
            case 7:
                return 7;
            case 8:
                if (this.sno.repaymentSno) return 9;
                return 8;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 0;
            }
        },
        titleName() {
            switch (this.QueryType) {
            case 1:
                return '銷貨發票';
            case 2:
                return '請款單';
            case 3:
                return '營業其他收入';
            case 4:
                return '財務資產收入';
            case 5:
                return '營業其他支出';
            case 6:
                return '財務資產支出';
            case 7:
                return '薪資支出';
            case 8:
                return this.datas.sno && this.datas.sno.repaymentSno ? '借款動撥還款' : '借款動撥';
            case 9:
                return '存款帳戶互轉';
            case 10:
                return '零用現金';
            default:
                return '--';
            }
        },
        documentDetail() {
            const { detail } = this.datas;
            if (detail) {
                switch (this.QueryType) {
                case 1:
                    return this.datas.detail?.item || {}; // 發票
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 8:
                case 9:
                case 10:
                    return this.datas.detail || {}; // 營業其他收入
                case 7: // 薪資支出
                    // eslint-disable-next-line no-case-declarations
                    const DATA = this.datas?.detail || {
                        bonusItems: [],
                        fixedSalaryItems: [],
                        nonFixedSalaryItems: [],
                        staffCostItems: [],
                        statisticsInfo: {},
                        statisticsItems: [],
                    };
                    return {
                        amount: DATA.amount,
                        bonusItems: _.head(DATA.bonusItems),
                        fixedSalaryItems: _.head(DATA.fixedSalaryItems),
                        nonFixedSalaryItems: _.head(DATA.nonFixedSalaryItems),
                        staffCostItems: _.head(DATA.staffCostItems),
                        statisticsInfo: DATA.statisticsInfo,
                        statisticsItems: _.head(DATA.statisticsItems),
                    };
                default:
                    return '--';
                }
            } else {
                return '';
            }
        },
        content() {
            console.log(this.documentDetail);
            switch (this.QueryType) {
            case 1:
                return this.documentDetail.description;
            case 2:
                return this.documentDetail.nam;
            case 3:
            case 4:
            case 5:
            case 6:
                return this.documentDetail.tpc;
            case 7: // 薪資支出
                if (!this.documentDetail.fixedSalaryItems) return '';
                return `${moment(`${this.documentDetail.fixedSalaryItems.year}/${this.documentDetail.fixedSalaryItems.month}/01`).format('YYYY-MM')} 薪資支出`;
            case 8:
                if (this.datas.detail?.repaymentList) return `${this.documentDetail.summary} 動播 ${this.documentDetail.amount} 元`;
                return `還款 - ${this.documentDetail.summary}`;
            case 9:
                return '存款帳戶互轉';
            case 10:
                return this.documentDetail.typ === 1 ? '轉入' : '轉出';

            default:
                return '--';
            }
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        settingsForSelect() {
            return this.$store.getters['accounting/settingsForSelect'];
        },
        validVouchers() {
            return this.vouchers.filter((v) => v.cnl !== true);
        },
        voidVouchers() {
            return this.vouchers.filter((v) => v.cnl === true);
        },
        approvedVoucherCount() {
            const approvedVouchers = this.vouchers.filter((v) => v.status === 1);
            return approvedVouchers.length;
        },
        unapproveVoucherCount() {
            const unapproveVouchers = this.vouchers.filter((v) => v.status === 0);
            return unapproveVouchers.length;
        },
        canceledVoucherCount() {
            const cenceledVouchers = this.vouchers.filter((v) => v.cnl === true);
            return cenceledVouchers.length;
        },

        // salaryUniqueNumber() {
        //     if (!this.sno) return '--';
        //     const TIME = moment(`${this.sno.year}/${this.sno.month}/01`).format('YYYYMM');
        //     return `SA${TIME}`;
        // },
        UNT_NBR() {
            switch (this.QueryType) {
            case 1:
                return this.datas.detail.item.ioo;

            case 2:
                return this.datas.detail.payoo;
            case 3:
            case 4:
            case 5:
            case 6:
                return this.datas.detail.moo;

            case 7:
                return moment(`${this.sno.year}/${this.sno.month}/01`).format('YYYYMM');
            case 8:
            case 9:
            case 10:
                return this.datas.detail.systemNo;
            default:
                return '';
            }
        },
        isBatchApprove() {
            return _.chain(this.vouchers)
                .filter((v) => !v.cnl)
                .find(['status', 0])
                .value();
        },
        isAccountingComplete() {
            return this.datas?.detail?.vocherStatus === 1;
        },
        isAccountingWaitForCheck() {
            return this.datas && this.datas.detail && this.datas.detail.vocherStatus === 0;
        },
        isNoAccountingNeed() {
            return this.datas && this.datas.detail && this.datas.detail.vocherStatus === 2;
        },

        isVoucherStatusDisabled() {
            const validVouchers = this.vouchers.filter((x) => !x.cnl); // not canceled
            return !!_.find(validVouchers, ['status', 0]);
        },
        paymentWithholdItem() {
            return this.documentDetail.payoutSno ? { payoutNo: this.documentDetail.payoutNo, payoutSno: this.documentDetail.payoutSno } : undefined;
        },
        userGrP_NO() {
            return this.$store.getters['account/userGrP_NO'];
        },
        isSwitchShow() {
            return this.userGrP_NO === 'OT1' || this.userGrP_NO === 'OT2' || this.userGrP_NO === 'OT3' || this.userGrP_NO === 'OT4' || this.isSAAdmin;
        },
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        isUnbalanceAlertShow() {
            return this.QueryType === 1 || this.QueryType === 2 || this.QueryType === 5 || this.QueryType === 6;
        },
        unbalanceAlertSpace() {
            switch (this.unbalanceAlert) {
            case 'Invoice':
                return '40px';
            case 'Payment':
                return '90px';
            default:
                return '0px';
            }
        },
        unbalanceAlert() {
            switch (this.QueryType) {
            case 1:
                return 'Invoice';
            case 2:
            case 5:
            case 6:
                return 'Payment';
            default:
                return 'Error';
            }
        },
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },
    },
    methods: {
        async onOpen() {
            await this.$store.dispatch('accounting/updateAccountingSettings');
        },
        async updateData() {
            this.isLoadingData = true;
            let subUrl;
            let params;
            switch (this.QueryType) {
            case 1:
                subUrl = 'GetInvoiceDetail';
                params = { sno: this.sno };
                break;
            case 2:
                subUrl = 'GetPayoutDetail';
                params = { sno: this.sno };
                break;
            case 3:
            case 4:
            case 5:
            case 6:
                subUrl = 'GetVariableStatementDetail';
                params = { sno: this.sno };
                break;
            case 7:
                subUrl = 'GetSalaryDetail';
                params = { Year: this.sno.year, Month: this.sno.month };
                break;
            case 8:
                if (this.sno.repaymentSno) {
                    subUrl = 'GetLoanRepaymentDetail';
                    params = { sno: this.sno.repaymentSno };
                } else {
                    subUrl = 'GetLoanDrawdownDetail';
                    params = { sno: this.sno.drawdownSno };
                }
                break;
            case 9:
                subUrl = 'GetAccountTransferRecordDetail';
                params = { sno: this.sno };
                break;
            case 10:
                subUrl = 'GetPettyCashDetail';
                params = { sno: this.sno };
                break;
            default:
            }

            const resp = await this.$api({
                url: `AccountingSummaryPage/${subUrl}`,
                method: 'GET',
                params,
            });
            // console.log('detail data', resp.data);
            this.datas = resp.data;
            this.originalVocherStatus = this.datas.detail.vocherStatus;
            this.isLoadingData = false;
        },
        clearDatas() {
            this.datas.sno = null;
            this.datas.uniqueNumber = null;
            this.datas.createDate = null;
            this.datas.name = null;
            this.datas.typeName = null;
            this.datas.amount = null;
            this.datas.tax_Amount = null;
            this.datas.credentialsName = null;
            this.datas.withholdingTax_Labor = null;
            this.datas.withholdingTax_Health2 = null;
            this.datas.payType = null;
            this.vouchers = [];
            this.editingVoucher.vono = 0;
            this.isEdited = false;
            this.accItemsToDelete = [];
            this.isEditing = false;
        },
        async fetchVouchers() {
            this.isLoadingVouchers = true;
            try {
                const resp = await this.$api({
                    url: '/AccountingSummaryPage/GetVouchers',
                    params: {
                        UNT_NBR: this.UNT_NBR,
                    },
                    method: 'GET',
                });

                this.vouchers = resp.data.items;
            } finally {
                this.isLoadingVouchers = false;
            }
        },
        async onBeforeClose(forceRefresh) {
            try {
                if (this.isEditing) {
                    await this.$confirm('傳票尚在編輯中，確定要關閉嗎？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });
                }

                if (this.paymentWithholdSno) {
                    this.$emit('reOpen', 6, this.paymentWithholdSno);
                    this.paymentWithholdSno = null;
                } else this.$emit('close', !!this.isEdited || forceRefresh);
            } catch (e) {
                console.log(e);
            }
        },
        onApproveMutated() {
            this.isEdited = true;
            this.fetchVouchers();
        },
        async changeStatus(statusName) {
            const status = accountingStatusOptions.find((item) => item.name === statusName);
            const statusNum = status?.key;
            // console.log('statusName', statusName);
            // console.log('accountingStatusOptions', accountingStatusOptions);
            // console.log('status', status);
            // console.log('statusNum', statusNum);

            if (statusNum === undefined || statusNum === null) {
                this.$message({
                    showClose: true,
                    message: `無效的狀態 ${statusName}`,
                    type: 'error',
                });
                return;
            }

            try {
                this.isEdited = true;
                this.isEditing = true;
                let { sno } = this;
                if (this.QueryType === 7) sno = undefined;
                else if (this.QueryType === 8 && this.sno.repaymentSno) sno = this.sno.repaymentSno;
                else if (this.QueryType === 8 && !this.sno.repaymentSno) sno = this.sno.drawdownSno;

                const resp = await this.$api({
                    url: '/AccountingSummaryPage/UpdateAccountStatus',
                    method: 'post',
                    data: [
                        {
                            sno,
                            voucherType: this.QueryTypeToVoucherType(this.QueryType),
                            unt: this.getUntName(this.QueryType),
                            UNT_NBR: this.UNT_NBR,
                            status: statusNum,
                        },
                    ],
                });

                if (resp.data.success.length) {
                    this.$message({
                        showClose: true,
                        message: '財會檢核狀態已儲存',
                        type: 'success',
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: '含有未核准傳票或帳務狀態未完成，無法完成財會檢核。',
                        type: 'error',
                    });
                }
                await this.updateData();
                await this.fetchVouchers();
                this.$emit('update');
            } catch (e) {
                console.log(e);
                this.isEdited = false;
                this.datas.detail.vocherStatus = this.originalVocherStatus;
            } finally {
                this.isEditing = false;
            }
        },
        QueryTypeToVoucherType(queryType) {
            switch (queryType) {
            case 1:
                return 1; // 發票收入
            case 2:
                return 2; // 請款支出
            case 3:
            case 4:
            case 5:
            case 6:
                return 3; // 財務收支
            case 7:
                return 4; // 薪資支出
            case 8:
                return this.sno.repaymentSno ? 7 : 6; // 借款管理
            case 9:
                return 8; // 存款帳戶互轉
            case 10:
                return 9; // 零用現金
            default:
                return 0;
            }
        },
        // getVoucherItemSum(voucher, type) {
        //     if (type === 'crd') return _.sumBy(voucher.accountItems, 'crD_NTD');
        //     if (type === 'deb') return _.sumBy(voucher.accountItems, 'deB_NTD');
        //     return 0;
        // },
        getUntName(queryType) {
            switch (queryType) {
            case 1:
                return 'INVOICE'; // 發票收入
            case 2:
                return 'PAYMENT'; // 請款支出
            case 3:
            case 4:
            case 5:
            case 6:
                return 'MONEY_INOUT'; // 財務收支
            case 7:
                return 'SALARY'; // 薪資支出
            case 8:
                return this.sno.repaymentSno ? 'LoanReceiptRepayment' : 'LoanReceiptDrawdown'; // 借款管理
            case 9:
                return 'TRANSFER';
            case 10:
                return 'PettyCash';
            default:
                return '';
            }
        },
        onPrintVouchers() {
            // console.log(this.vouchers);
            this.$router.push({ name: 'accounting-vouchers-print', params: { UNT_NBR: this.UNT_NBR } });
        },
        addVoucher(copyVoucher) {
            this.isEditing = true;

            // 產生空白傳票資料
            const newVoucher = {
                accountItems: [
                    {
                        accno: null,
                        accnO_SNO: null,
                        content: this.content,
                        crD_NTD: 0,
                        deB_NTD: 0,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                    {
                        accno: null,
                        accnO_SNO: null,
                        content: this.content,
                        crD_NTD: 0,
                        deB_NTD: 0,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                ],
                cnl: false,
                cny: 'TWD',
                dat: new Date().getTime(),
                mem: null,
                sno: null,
                unT_NBR: this.UNT_NBR,
                unt: this.getUntName(this.QueryType),
                vono: null,
                status: 0,
                voucherType: this.QueryTypeToVoucherType(this.QueryType),
                isEditing: true, // 進入編輯模式
            };

            // 如果此帳務本身沒有任何傳票，預設代入帳務的金額
            if (this.vouchers.length === 0) {
                newVoucher.accountItems[0].content = this.content;
                newVoucher.accountItems[0].crD_NTD = this.datas.amount;
                newVoucher.accountItems[0].deB_NTD = 0;
                newVoucher.accountItems[1].content = this.content;
                newVoucher.accountItems[1].crD_NTD = 0;
                newVoucher.accountItems[1].deB_NTD = this.datas.amount;
            }

            // 複製模式，套用所有來源傳票的會計項目＆日期
            if (copyVoucher) {
                newVoucher.dat = copyVoucher.dat;
                newVoucher.accountItems = [];
                copyVoucher.accountItems.forEach((item) => {
                    newVoucher.accountItems.push({
                        vono: item.vono,
                        accnO_SNO: item.accnO_SNO,
                        accno: item.accno,
                        content: item.content,
                        crD_NTD: item.crD_NTD,
                        deB_NTD: item.deB_NTD,
                    });
                });
            }
            this.vouchers.push(newVoucher);

            // focus 到此張傳票
            this.focusOnEditingVoucher();
        },
        getVoidAccountTypeSno() {
            switch (this.QueryType) {
            case 7: // 薪資支出
                return undefined;
            case 8:
                if (this.sno.repaymentSno) return this.sno.repaymentSno;
                return this.sno.drawdownSno;

            default:
                return this.sno;
            }
        },
        /**
         * 以下操作未來應移至 VoucherCard 獨立運行
         */
        async onSubmitVoucher() {
            /*
            const newVoucherData = params.voucherData;
            const voucherItemsToDelete = params.itemsToDelete;

            console.log('newVoucherData', newVoucherData);
            console.log('voucherItemsToDelete', voucherItemsToDelete);

            if (!newVoucherData) return;

            // 移除空白項目
            // voucher.accountItems = voucher.accountItems.filter((item) => item.accno !== null);

            // 儲存變更
            await this.$api({
                url: '/AccountingSummaryPage/UpsertVouchers',
                method: 'POST',
                data: { UNT_NBR: this.UNT_NBR, ...newVoucherData },
            });

            // 刪除傳票項目
            for (let i = 0; i < voucherItemsToDelete.length; i += 1) {
                // eslint-disable-next-line no-await-in-loop
                await this.$api({
                    url: '/AccountingSummaryPage/DeleteVoucherDetail',
                    method: 'POST',
                    data: {
                        sno: voucherItemsToDelete[i],
                        vono: newVoucherData.vono,
                    },
                });
            }
            this.fetchVouchers();
            */
            this.isEdited = true;
            this.isEditing = false;
            this.fetchVouchers();
        },
        async onCancelVoucher(voucher) {
            // 新增傳票未儲存就按取消，移除
            if (!voucher.sno) {
                const idx = this.vouchers.indexOf(voucher);
                if (idx) {
                    this.vouchers.splice(idx, 1);
                }
            }
            this.isEditing = false;
        },
        async onVoidVoucher(voucher) {
            /*
            await this.$api({
                url: '/AccountingSummaryPage/VoidVoucher',
                method: 'POST',
                data: {
                    queryType: this.QueryTypeToVoucherType(this.QueryType),
                    voucherSno: voucher.sno,
                    accountTypeSno: this.getVoidAccountTypeSno(this.QueryType),
                    UNT_NBR: this.QueryType === 7 ? this.UNT_NBR : undefined,
                },
            });
            */
            this.isEdited = true;
            this.fetchVouchers();
        },

        async onCancelVoidVoucher(voucher) {
            /*
            await this.$api({
                url: '/AccountingSummaryPage/CancelVoidVoucher',
                method: 'POST',
                data: {
                    queryType: this.QueryTypeToVoucherType(this.QueryType),
                    voucherSno: voucher.sno,
                    accountTypeSno: this.getVoidAccountTypeSno(this.QueryType),
                    UNT_NBR: this.QueryType === 7 ? this.UNT_NBR : undefined,
                },
            });
            */
            this.isEdited = true;
            this.fetchVouchers();
        },

        async onDeleteVoucher(voucher) {
            // await this.$api({
            //     url: '/AccountingSummaryPage/DeleteVoucher',
            //     method: 'POST',
            //     data: { sno: voucher.sno },
            // });
            this.isEdited = true;
            this.fetchVouchers();
        },

        onEditVoucher() {
            this.isEditing = true;
            this.focusOnEditingVoucher();
        },

        async onBatchUpdateVoucherStatus() {
            const SET_TO = this.isBatchApprove ? 1 : 0;
            const validVouchers = this.vouchers.filter((x) => !x.cnl); // not canceled
            const data = _.chain(validVouchers)
                .filter((o) => !this.emptyAccountingItemVoucherList.includes(o.serialNumber))
                .map((o) => ({ sno: o.sno, status: SET_TO }))
                .value();

            try {
                this.isActionLoading = true;
                this.isEdited = true;
                await this.$api({
                    url: '/AccountingSummaryPage/UpdateVoucherStatus',
                    method: 'POST',
                    data,
                });
                if (this.emptyAccountingItemVoucherList.length) {
                    await this.$msgbox({
                        title: '',
                        message: `傳票：${this.emptyAccountingItemVoucherList.join(', ')} 尚有會計科目未選擇，無法核准該傳票。`,
                        confirmButtonText: '我瞭解了',
                        closeOnClickModal: false,
                        showClose: false,
                    });
                }
                this.$message({ showClose: true, message: this.isBatchApprove ? '傳票已核准' : '已取消核准', type: 'success' });
                this.fetchVouchers();
            } catch (ex) {
                this.$message({ showClose: true, message: '無法核准傳票', type: 'error' });
            } finally {
                this.isActionLoading = false;
            }
        },
        async onBulkReAutoVoucher() {
            try {
                this.isActionLoading = true;
                await this.$confirm('確定要重新自動產生傳票？（原本已存在的傳票將會被覆蓋）', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoadingVouchers = true;
                this.isEdited = true;
                const data = { generateType: this.generateType };

                switch (this.QueryType) {
                case 7:
                    data.sno = null;
                    data.salaryQueryMonth = this.sno;
                    break;
                case 8:
                    if (this.sno.repaymentSno) data.sno = this.sno.repaymentSno;
                    else data.sno = this.sno.drawdownSno;
                    data.salaryQueryMonth = null;
                    break;
                default:
                    data.sno = this.sno;
                    data.salaryQueryMonth = null;
                    break;
                }

                const resp = await this.$api({
                    url: '/AccountingSummaryPage/GenerateAutoVoucher',
                    method: 'POST',
                    data: [data],
                });

                if (resp.data.errorResult.length) {
                    this.$message({
                        showClose: true,
                        message: _.first(resp.data.errorResult)?.errorMessage,
                        type: 'error',
                    });
                    return;
                }

                this.$message({ showClose: true, message: '自動產生完成', type: 'success' });
                this.fetchVouchers();
                this.$emit('update');
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoadingVouchers = false;
                this.isActionLoading = false;
            }
        },

        onGeneratePaymentVoucher(data) {
            this.isEditing = true;
            const LAST_ACCNO = this.documentDetail.typ === 2 ? '2121' : '2131';

            const newVoucher = {
                accountItems: [
                    {
                        accno: this.documentDetail.accno,
                        accnO_SNO: this.getAccnoSnoByAccno(this.documentDetail.accno),
                        content: this.content,
                        crD_NTD: data.amt - data.tax,
                        deB_NTD: 0,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                    {
                        accno: '1290',
                        accnO_SNO: this.getAccnoSnoByAccno('1290'),
                        content: `發票號碼：${data.foo}／賣方統編：${data.bsn || '無'}`,
                        crD_NTD: data.tax,
                        deB_NTD: 0,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                    {
                        accno: LAST_ACCNO,
                        accnO_SNO: this.getAccnoSnoByAccno(LAST_ACCNO),
                        content: this.content,
                        crD_NTD: 0,
                        deB_NTD: data.amt,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                ],
                cnl: false,
                cny: 'TWD',
                dat: data.foO_DAT,
                mem: null,
                sno: null,
                unT_NBR: this.UNT_NBR,
                unt: this.getUntName(this.QueryType),
                vono: null,
                status: 0,
                voucherType: this.QueryTypeToVoucherType(this.QueryType),
                isEditing: true, // 進入編輯模式
            };

            this.vouchers.push(newVoucher);

            this.$nextTick(() => {
                document.querySelector('.voucher-card.editing').scrollIntoView({
                    block: 'center',
                    behavior: 'smooth',
                });
            });
        },
        onGenerateReimbursementInvoiceVoucher(data) {
            this.isEditing = true;
            const LATEST_ITEMSNO_ACCNO = this.getAccnoByItemSno(this.documentDetail.incomeItemNo);

            const newVoucher = {
                accountItems: [
                    {
                        accno: LATEST_ITEMSNO_ACCNO,
                        accnO_SNO: this.getAccnoSnoByAccno(LATEST_ITEMSNO_ACCNO),
                        content: data.description,
                        crD_NTD: data.tranInvoiceAmount,
                        deB_NTD: 0,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                    {
                        accno: '4100',
                        accnO_SNO: this.getAccnoSnoByAccno('4100'),
                        content: `${data.description} - 發票號碼：${data.foo}`,
                        crD_NTD: 0,
                        deB_NTD: data.tranInvoiceAmount - data.amT_TAX,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                    {
                        accno: '2134',
                        accnO_SNO: this.getAccnoSnoByAccno('2134'),
                        content: `${data.description} - 發票號碼：${data.foo}-稅金`,
                        crD_NTD: 0,
                        deB_NTD: data.amT_TAX,
                        vocherSno: null,
                        vono: null,
                        sno: null,
                    },
                ],
                cnl: false,
                cny: 'TWD',
                dat: data.foO_DAT,
                mem: null,
                sno: null,
                unT_NBR: this.UNT_NBR,
                unt: this.getUntName(this.QueryType),
                vono: null,
                status: 0,
                voucherType: this.QueryTypeToVoucherType(this.QueryType),
                isEditing: true, // 進入編輯模式
            };

            this.vouchers.push(newVoucher);

            this.$nextTick(() => {
                document.querySelector('.voucher-card.editing').scrollIntoView({
                    block: 'center',
                    behavior: 'smooth',
                });
            });
        },

        getAccnoSnoByAccno(accno) {
            const FOUND = _.chain(this.settingsForSelect).flatMap('children').find(['accno', accno]).value();
            return FOUND ? FOUND.sno : null;
        },
        getAccnoByItemSno(itemSno) {
            let latestAccno;
            _.forEach(this.statementOptions, (value) => {
                const FOUND = _.find(_.flatMap(value, 'childSettings'), ['sno', itemSno]);
                if (FOUND) latestAccno = FOUND.accno;
            });
            return latestAccno;
        },
        focusOnEditingVoucher() {
            setTimeout(() => {
                document.querySelector('.voucher-card.editing').scrollIntoView({
                    block: 'center',
                    behavior: 'smooth',
                });
            }, 20);
        },

        openPaymentDetail(sno) {
            this.$emit('reOpen', 2, sno);
            this.paymentWithholdSno = this.sno;
        },

        onDupicateVoucher(voucher) {
            this.addVoucher(voucher);
        },
        onStatusDropdown(command) {
            this.changeStatus(command);
        },
        async onDetailClose(reload) {
            if (reload) {
                this.isEdited = true;
                this.updateData();
                this.fetchVouchers();
            }
        },
        onDetailDataChanged() {
            this.updateData();
            this.fetchVouchers();
        },
        onDetailRequestRegenerateVouchers() {
            this.updateData();
            this.onBulkReAutoVoucher();
        },
    },
};
</script>

<style lang="scss">
.accounting-summary-detail-dialog.ah-accounting-detail-dialog {
    .el-dialog {
        max-width: 1300px;
        background-color: #dbe3f0;
        margin-bottom: 0 !important;
        height: 96vh;
        border-radius: 20px;
        overflow: hidden;
    }

    .el-dialog__header {
        display: none;
    }

    .unique-number-btn {
        margin-left: 10px;
        color: #000;
        font-weight: bold;
        text-decoration: underline;
    }

    .dialog-grid {
        display: grid;
        grid-template-columns: 35% auto;

        &.wideDetail {
            grid-template-columns: 40% auto;
        }

        /* 左側資料區塊 */
        > .detail-area {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            border-right: 1px solid #e6e6e6;
            background-color: #fff;
            overflow: hidden;

            > .area-header {
                position: relative;
                padding-left: 40px;
                padding-right: 25px;
                // background-color: #eaedf2;
                // border-bottom: 1px solid #ddd;
            }

            > .detail-card-scrollview {
                overflow: auto;
                height: calc(96vh - 60px);
                border-top: 1px solid #ddd;

                &::-webkit-scrollbar {
                    width: 10px;
                }
                &::-webkit-scrollbar-track {
                    background: #eaedf2;
                }
                &::-webkit-scrollbar-thumb {
                    width: 8px;
                    background: #ccc;
                    border-radius: 5px;
                    border: 2px solid #eaedf2;
                }
                &::-webkit-scrollbar-thumb:hover {
                    background: #aaa;
                }
            }
        }

        /* 右側傳票列表區塊 */
        > .voucher-area {
            background-color: #dfe3ef;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            overflow: hidden;

            > .area-header {
                position: relative;
                background-color: #fff;
                color: #666;
                font-size: 10pt;
            }
            > .voucher-card-scrollview {
                // background-color: #dedee1;
                border-top: 1px solid #cfd8e5;
                overflow: auto;
                height: calc(96vh - 60px);
                padding-bottom: 130px;

                &::-webkit-scrollbar {
                    width: 10px;
                }
                &::-webkit-scrollbar-track {
                    background: #eaedf2;
                }
                &::-webkit-scrollbar-thumb {
                    border: 2px solid #eaedf2;
                    background: #ccc;
                    border-radius: 5px;
                }
                &::-webkit-scrollbar-thumb:hover {
                    background: #aaa;
                }
            }
        }

        .area-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            // background-color: #eaedf2;
            height: 60px;
            padding: 0 20px;
        }
    }
    .accounting-summary-dialog-header {
        display: grid;
        grid-template-columns: 35% auto;
        .detail-info-block {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 15px;
        }
        .action {
            display: flex;
            justify-content: flex-end;
            padding-right: 40px;
        }
    }

    .detail-table {
        padding: 25px;
    }

    .accounting-summary-detail-table {
        width: 100%;

        > tbody {
            > tr {
                > th {
                    text-align: left;
                    font-size: 10pt;
                    font-weight: normal;
                    border-bottom: 1px solid #eee;
                    padding: 8px 0;
                }
                > td {
                    text-align: right;
                    font-size: 10pt;
                    font-weight: bold;
                    border-bottom: 1px solid #eee;
                    padding: 8px 0;
                }
            }
        }
    }

    &.print {
        position: relative;
        margin: 0;
        padding: 0;

        .el-dialog {
            margin: 0;
            margin-top: 0 !important;
            padding: 0;
            border: 0;
            box-shadow: none;
            width: 100%;
            max-width: unset;

            .el-dialog__header {
                display: none;
            }
        }
        .dialog-grid {
            display: block;
        }
        .acc-summ-detail-infos {
            display: none;
        }
        .acc-summ-detail-main {
            > .actions {
                display: none;
            }
        }
    }

    /* 左側資料樣式 */
    .accounting-detail-data {
        .detail-container {
            padding: 25px 40px 80px 40px;
        }

        .detail-section {
            margin-bottom: 60px;

            .section-title {
                font-size: 10pt;
                font-weight: bold;
                padding-bottom: 4px;
                border-bottom: 1px solid #000;
            }
        }

        .accounting-detail-items {
            display: table;
            width: 100%;
            font-size: 10pt;
            line-height: 150%;

            > .item {
                display: table-row;

                > .label {
                    display: table-cell;
                    width: 100px;
                    padding-bottom: 8px;
                    padding-right: 15px;
                    color: #888;
                    vertical-align: top;
                }
                > .value {
                    display: table-cell;
                    padding-bottom: 8px;
                    vertical-align: top;

                    &.large {
                        font-size: 18pt;
                    }

                    &.xl {
                        font-size: 18pt;
                        line-height: 140%;
                    }

                    &.b {
                        font-weight: bold;
                    }

                    .cny {
                        font-size: 9.5pt;
                        margin-left: 6px;
                    }

                    .el-button--text {
                        padding-top: 0;
                        padding-bottom: 0;
                    }
                }

                &.spacing-top {
                    > .label,
                    > .value {
                        padding-top: 16px;
                    }
                }

                &.vertical {
                    display: block;
                    > .label,
                    > .value {
                        display: block;
                        padding-bottom: 5px;
                    }
                }
            }
        }

        .accounting-detail-table {
            width: 100%;
            font-size: 10pt;

            th,
            td {
                padding: 2px;

                &.right {
                    text-align: right;
                }
            }

            th {
                text-align: left;
                font-weight: normal;
                color: #888;
                border-bottom: 1px solid #ccc;
            }

            td {
                border-bottom: 1px solid #ccc;
            }
        }

        .split-view {
            display: flex;
            align-items: flex-start;
            gap: 20px;
        }

        .attachment-rect {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 15px;
            background-color: #fff;
            border: 1px solid #ccc;
            width: 120px;
            height: 160px;
            flex-shrink: 0;
        }
    }
    .unpaid-msg {
        padding: 30px 40px;
        margin: 20px;
        border-radius: 8px;
        color: #946a2b;
        background-color: rgb(255, 255, 173);

        > .title {
            font-weight: bold;
            font-size: 13pt;
            margin-bottom: 10px;
        }
        > .description {
            display: grid;
            grid-template-columns: auto 150px;

            > div:nth-child(2) {
                text-align: center;
            }
        }

        a {
            text-decoration: none;
        }
    }
    .accounting-check-bar {
        position: sticky;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 15px 15px 40px;
        background-color: #fff;
        border-bottom: 1px solid #ddd;

        > .title {
            display: flex;
            align-items: center;
            gap: 12px;
            color: #463cb2;
            font-size: 10pt;
            font-weight: bold;
            cursor: default;

            > i {
                font-size: 14pt;
            }

            > .label {
                display: flex;
                align-items: center;
                gap: 8px;
                border: 1px solid #463cb2;
                border-radius: 4px;
                padding: 2px 10px;
            }
        }
        .last-status-mutate-info {
            font-size: 9pt;
            color: #444;
        }
        &.wait-for-check {
            > .title {
                color: #ef6401;
                > .label {
                    border-color: #ef6401;
                }
            }
        }

        &.complete {
            > .title {
                color: #0baa1b;
                > .label {
                    border-color: #0baa1b;
                }
            }
        }
        &.no-accounting-need {
            > .title {
                color: #aaa;
                > .label {
                    border-color: #ccc;
                }
            }
        }
    }
}

.alert-msg-container {
    position: sticky;
    top: 0;
    z-index: 1;
    width: calc(100%);
    margin: 0 auto;
}
.alert-msg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    // border-radius: 8px;
    color: #e6a23c;
    font-size: 10.5pt;
    font-weight: bold;
    background-color: #fcf2e4;
    cursor: default;

    &:hover {
        background-color: #feedd4;
    }
    &:not(:first-child) {
        // margin-top: 5px;
    }
}
</style>
